import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnChanges, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
faChevronRight,
faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons';
import { faCalendarDay } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import moment from 'moment';
import { TruncatePipe } from '@app/shared/pipes/truncate/truncate.pipe';
import { ImgPipe } from '@app/shared/pipes/img/img.pipe';


@Component({
  selector: 'app-application-card',
  templateUrl: './application-card.component.html',
  styleUrls: ['./application-card.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule, TruncatePipe, ImgPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ApplicationCardComponent implements OnChanges {

  @Input() application?: any;

  faMapMarkerAlt = faMapMarkerAlt;
  faChevronRight = faChevronRight;
  faCalendar = faCalendarDay;

  futureStatus: string;

  constructor() { }

  ngOnChanges() {
    this.futureStatus = this.application.states === 'Reserved' && this.application.signedcontract === null ? 'Sign Agreement' :
    this.application.states === 'Reserved' && this.application.signedcontract !== null ? 'Complete Application' :
    this.application.states === 'Enrolled' && moment().isAfter(moment(this.application.enddate)) ? 'Submit Review' :
    this.application.states === 'Accepted' && this.application.madedeposit === false ? 'Pay and Reserve' :
    this.application.states === 'Pending' && this.application.program.preapprovalrequired === true ? 'Awaiting Acceptance' :
    this.application.states === 'Pre-Approved' && this.application.program.preapprovalrequired === true ? 'Upload Documents' :
    this.application.states === 'Pending' && this.application.program.preapprovalrequired === false ? 'Book now' :
    this.application.states;
  }
}
